import React from "react";
import AntdTree, { TreeProps } from "antd/lib/tree";
import {withError} from '@fishx/tracker';

const TreeNode = AntdTree.TreeNode;
const DirectoryTree = AntdTree.DirectoryTree;

interface FCTreeProps extends React.FC<TreeProps> {
  TreeNode: typeof TreeNode;
  DirectoryTree: typeof DirectoryTree;
}
export const Tree: FCTreeProps = (props) => {
  return (
    <AntdTree {...props} />
  )
}
Tree.TreeNode = TreeNode;
Tree.DirectoryTree = DirectoryTree;
Tree.displayName = 'Tree';
export default withError(Tree);



// WEBPACK FOOTER //
// ./src/components/tree/index.tsx